import { useGetGiftCardV3 } from '@ordr-as/ordr-service-types/epos';

export const useGiftCardSearch = (locationId: number, query: string, giftCardSource: 'INTERNAL' | 'EXTERNAL') => {
  const { queryKey: _queryKey, ...result } = useGetGiftCardV3(
    locationId,
    { source: giftCardSource, query },
    {
      query: {
        enabled: !!locationId,
      },
    }
  );
  return result;
};
